'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import type { LandingNav, LandingTheme } from '../../_lib/schema/landing-config.schema';
import { FloatingSiteFooter, FloatingSiteHeader } from './floating-site-chrome';
import { landingThemeStyle } from './landing-design';

export function FloatingTenantChrome({ nav, theme, logoUrl, footer = false, fallback, accountControl, languageControl, memberNavigation, legalControls }: {
  nav: LandingNav;
  theme?: LandingTheme;
  logoUrl?: string | null;
  footer?: boolean;
  fallback: ReactNode;
  accountControl?: ReactNode;
  languageControl?: ReactNode;
  memberNavigation?: ReactNode;
  legalControls?: ReactNode;
}) {
  const pathname = usePathname();
  const { i18n } = useTranslation();
  if (pathname !== '/' && !pathname.startsWith('/pages/')) return fallback;

  return <div style={landingThemeStyle(theme)}>
    {footer
      ? <FloatingSiteFooter nav={nav} locale={i18n.language} logoUrl={logoUrl} legalControls={legalControls} />
      : <FloatingSiteHeader nav={nav} locale={i18n.language} logoUrl={logoUrl} accountControl={accountControl} languageControl={languageControl} memberNavigation={memberNavigation} />}
  </div>;
}
